import { t } from '@lingui/core/macro';
import ContentLoader, { type IContentLoaderProps } from 'react-content-loader';

import { SKELETON_BACKGROUND_COLOR, SKELETON_FOREGROUND_COLOR } from '@/constants/colors';

const SkeletonLoader = (props: IContentLoaderProps) => (
  <ContentLoader
    foregroundColor={SKELETON_FOREGROUND_COLOR}
    backgroundColor={SKELETON_BACKGROUND_COLOR}
    speed={1.5}
    {...props}
    role="status"
    aria-label={t`Loading...`}
  />
);

export default SkeletonLoader;
